// 更新滚动条大小和位置
export default {
  data() {
    return {
      loading: true,
      uploadUrl: this.GLOBAL.BASE_URL + '/api/common/upload_file',
      dialogImageUrl: '',
      dialogVisible: false,
      textarea: '',
      // 分页插件
      pageform: {
        total: 0,
        pages: 5, // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 3, // 每页显示条目个数

      },

      // params: {
      //   class_id: this.$store.getters.getUserInfo.class_id,
      //   page_size: 3,
      //   page: 1,
      //   type: 1,
      // },
      task_id: '',
      tabledata: '',
      timer: '',
      ImgList: [],
      index: '',
      imgurl: '',
      isremove: false,
      dialogVisible: false,
      dialogImageUrl: '',
      code:'',
      markcode:'',
      // region:''
    }

  },
  created: function () {
    this.gettasklist()
    this.getsjCode()
	this.getmarkCode()
  },
  methods: {
	 //获取器械认知随机码
	  getmarkCode() {
	    this.$http.getmarkCode()
	      .then(res => {
	        if (res.code == 200) {
	          this.markcode=res.data
	        } else {
	          this.$message.error(res.message);
	        }
	      });
	  },
    //获取随机码
     getsjCode() {
      this.$http
        .getsjCode()
        .then(res => {
          if (res.code == 200) {
            this.code=res.data
          } else {
            this.$message.error(res.message);
          }
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    hello: function (val) {
      console.log(val)
    },
    beforeAvatarUpload(file) {
      // let types = ['image/jpeg', 'image/jpg', 'image/png'];
     // const isImage = types.includes(file.type);
       const isJPG = file.type === 'image/jpeg'|| file.type === 'image/png'|| file.type === 'image/jpeg';
      if (!isJPG) {
        this.$message.error('上传图片只能是JPG和png和jpeg格式!');
      }
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!');
      }
      return isLt2M && isJPG;
    },
    exceed(files, fileList) {
      alert("最多只能上传2张图片！")
    },
    // goselect(data) {

    //     var {region}=data
    //     this.region=region
    //     console.log(region);
    //     return;
    //     if (region == 0) {
    //       this.gettasklist()
    //     } else {
    //       this.gettypelist(region)
    //     }
    //   },
    //查看成绩
    golook(item) {
      // console.log(item)
      // return;

      this.$router.push({
        path: '/ucenter/examarrangement',
        query: {
          task_id: item.id,
          type: item.cate.id
        }
      })
    },
    //全部列表
    gettasklist() {
      this.$http.taskclass(this.params)
        .then(res => {
          if (res.code != 0) {
            this.loading = false;
            var tabledata = res.data.task;
            this.pageform.pages = res.data.allPage;
            this.pageform.total = res.data.allCount;
            var nowdate = new Date().getTime()
            for (var i = 0; i < tabledata.length; i++) {
              tabledata[i].textarea = ""
              tabledata[i].status = false
              tabledata[i].isstore = false
              tabledata[i].created_at1 = ''
              this.gettaskstatus(tabledata[i])
            }
           this.tabledata = tabledata.map(v => {
              var enddate = new Date(v.end_time).getTime();
              var startdate = new Date(v.start_time).getTime();
              var flags  = (nowdate > enddate) || (startdate > nowdate)
              this.$set(v, 'is_start', !flags)
              return v
            })
           console.log(this.tabledata);
          } else {
            this.$message.error(res.message)
          }

        })
    },
    //已完成未完成
    gettypelist(val, cate) {
      // console.log(this.region)
      // this.params = {
      //   page_size: 3,
      //   page: 1,
      //   type: 1,
      //   class_id: this.$store.getters.getUserInfo.class_id,
      // }
      this.$http.get_student_record(this.params)
        .then(res => {
          if (res.code != 0) {
            this.loading = false;

            if (val == 1 || val == 3) {
              var tabledata = res.data.finish.data;
              this.pageform.pages = res.data.finish.page;
              this.pageform.total = res.data.finish.count;
              console.log("finish")
            } else if (val == 2 || val == 4) {
              var tabledata = res.data.unfinish.data;
              this.pageform.pages = res.data.unfinish.page;
              this.pageform.total = res.data.unfinish.count;
              console.log("unfinish")
            } else {

            }
            for (var i = 0; i < tabledata.length; i++) {
              tabledata[i].textarea = ""
              tabledata[i].isstore = false
              tabledata[i].status = false
              tabledata[i].created_at1 = ''

              this.gettaskstatus(tabledata[i])
            }
            this.tabledata = tabledata

          } else {
            this.$message.error(res.message)
          }

        })
    },
    //素描提交
    smbtn(item) {

      console.log(item)
      if (item.student_answer.length > 0) {
        this.$confirm('你是否确定提交作业?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          var params = {
            task_id: item.id,
            student_answer: item.student_answer,
            student_des: item.textarea
          }
          this.$http.insert_student_record(params)
            .then(res => {
              if (res.code == 200) {
                this.$alert('提交成功', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {

                    if (this.region == 0) {
                      this.gettasklist()
                    } else {
                      this.gettypelist(this.region)
                    }
                  }

                });

              } else {
                this.$message.error(res.message)
              }

            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        this.$message({
          message: '请上传素描图片!',
          type: 'warning'
        });
      }

    },
    //作业状态
    gettaskstatus(item, i) {
      this.$http.taskstatus({
        task_id: item.id
      })
        .then(res => {
          if (res.code == 200) {
            if (res.data) {
              item.status = true
              item.created_at1 = res.data.created_at
              if (res.data.teacher_data) {
                item.isstore = true
              }
              if (res.data.student_des) {
                item.textarea = res.data.student_des
              }
              //this.$forceUpdate()
              var arr = []
              if (res.data.student_answer.length > 0) {
                for (var i = 0; i < res.data.student_answer.length; i++) {
                  var imgObject = {
                    "url": this.GLOBAL.BASE_URL + res.data.student_answer[i],
                    'name': i
                  }
                  arr.push(imgObject)
                }
                item.student_answer1 = arr
                item.student_answer = res.data.student_answer
              } else {
                item.student_answer1 = []
                item.student_answer = []
              }

            } else {
              item.status = false
              item.isstore = false
              item.student_answer = []
            }
          } else {
            item.student_answer1 = []
            item.student_answer = []
            item.status = false
            item.isstore = false

           // this.$message.error(res.message)
          }

        })
    },
    //提交
    submitbtn(item, type) {
      var nowdate = new Date().getTime()
      var enddate = new Date(item.end_time).getTime();
      var startdate = new Date(item.start_time).getTime();
      //   if ((nowdate > enddate) || (startdate > nowdate)) {
      var flags
      if (type == 1) {
        flags = nowdate > enddate
      } else {
        flags = (nowdate > enddate) || (startdate > nowdate)
      }
      if (flags) {
        if (type == 1) {
          this.$message({
            message: '不在做作业时间范围內！',
            type: 'warning'
          });
        } else {
          this.$message({
            message: '不在考试时间范围內！',
            type: 'warning'
          });
        }

      } else {
        //卡环
        if (item.cate.id == 2) {
          if (item.cate.url) {
            if (type == 1) {
              window.location.href =
                item.cate.url +
                "?data=" + this.$store.getters.getUserInfo.id + '+' + this.$store.getters.getUserInfo.realname + '+Job+' + item.tooth_num + '+' + item.id + '+' + this.GLOBAL.BASE_URL
            } else {
              window.location.href =
                item.cate.url +
                "?data=" + this.$store.getters.getUserInfo.id + '+' + this.$store.getters.getUserInfo.realname + '+Exam+' + item.tooth_num + '+' + item.id + '+' + this.GLOBAL.BASE_URL
            }

          } else this.$message("暂未开放");

        } else if (item.cate.id == 3||item.cate.id == 4) {
          //素描
          this.smbtn(item);
        } else if (item.cate.id == 5) {
          //器械认知
          var baseurl = this.GLOBAL.BASE_URL;
		  window.location.href =
		    item.cate.url +
		    "?user_id=" +
		    this.$store.getters.getUserInfo.id +
		    "+" +
		    baseurl+"+"+this.markcode+"+"+item.id;
        }else {
          if (item.cate.url) {
			//非卡环
			  var baseurl = this.GLOBAL.BASE_URL;
            if (type == 1) {
              /*window.location.href =
                item.cate.url +
                "?data=" + this.$store.getters.getUserInfo.id + '+' + this.$store.getters.getUserInfo.realname + '+Job+' + item.id + '+' + this.GLOBAL.BASE_URL*/
				window.location.href =
				  item.cate.url +
				  "?user_id=" +
				  this.$store.getters.getUserInfo.id +
				  "+" +
				  baseurl+"+"+this.code+"+"+"12";
            } else {
             /* window.location.href =
                item.cate.url +
                "?data=" + this.$store.getters.getUserInfo.id + '+' + this.$store.getters.getUserInfo.realname + '+Exam+' + item.id + '+' + this.GLOBAL.BASE_URL*/
                window.location.href =
                  item.cate.url +
                  "?user_id=" +
                  this.$store.getters.getUserInfo.id +
                  "+" +
                  baseurl+"+"+this.code+"+"+"12";
            }
          } else {
            this.$message("暂未开放");
          }
        }
        //跳转到开始详情页

        // this.$router.push({ path: '/ucenter/taskdetails', query: { item: JSON.stringify(item) } })
        // return;
        //卡环

      }
    },
    pagehandle(val) {
      this.pageform.pageNum = val;
      this.params.page = val;
      this.gettasklist();
    },
    // 产品详情 图片上传成功
    handleInfoSuccess(res, file, fileList, index) {

      // this.index
      // console.log(this.index)
      // //  let msg=this.$refs.dataMsg[0].$attrs['data-msg'];
      // //   console.log(msg)
      // //   msg.ImgList
      // console.log(res)
      // console.log(file)
      // this.ImgList.push(res.data)
      // console.log(this.ImgList)
      //  msg.ImgList=this.ImgList
      //  console.log(this.tabledata)
      //console.log(file.name)
     // console.log(this.tabledata);
     // console.log(this.tabledata[index])
     // console.log(123);
      this.tabledata[index]['student_answer'].push(this.$Base64.decode(res.data))
      var imgObject = {
        "url": this.GLOBAL.BASE_URL + this.$Base64.decode(res.data),
        'name': file.name
      }
      this.tabledata[index]['student_answer1'].push(imgObject)
      // this.ImgList.push(res.data)
      // console.log( this.ImgList)

      //  console.log(this.tabledata[index])
      //this.$forceUpdate()
    },
    // 产品详情 图片删除成功
    handleInfoRemove(file, fileList, index) {
      var arr = this.tabledata[index]['student_answer1'];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].name == file.name) {
          this.tabledata[index]['student_answer'].splice(i, 1)
          this.tabledata[index]['student_answer1'].splice(i, 1)
        }
      }

    },


  }
}



// WEBPACK FOOTER //
// ./src/components/assessment/task.js